import React, { Component, Fragment, createElement } from "react";
import Card from "../../../shared/Card/Card";
import InputCurrency from "../../../shared/InputCurrency/InputCurrency";
import Button from "../../../shared/button/button";
import { getRanksByFidelityAndMiles } from "../../shared/requests-api";
import Loading from "../../../shared/Loading/Loading";
import { formatCurrency, intFormat } from "../../../../js/shared/utils";

class RankingRankingTable extends Component {
	constructor(props) {
		super(props);
		this.state = {
			ranking: false,
			rankingValue: props.quant || null,
			rankingLoading: false,
			rankingOffers: [],
			enabled: true,
			handleMessage: false,
			errorQuant: ""
		};
	}

	componentDidMount() {
		this.getRanksByFidelityAndMilesFn();
	}

	getRanksByFidelityAndMilesFn = () => {
		this.setState({
			ranking: true,
			rankingLoading: true
		});

		getRanksByFidelityAndMiles(null, this.props.fidelityId, this.state.rankingValue, 15)
			.then(response => {
				this.setState({
					rankingLoading: false,
					rankingOffers: response.data
				});
			})
			.catch(err => {
				this.setState({
					rankingLoading: false,
					ranking: false
				});
				console.log("err", err);
			});
	};

	render() {
		const { fidelityId, simulator, quant, ...props } = this.props;
		let haveMyPosition = false;

		const onChangeFn = (str, val) => {
			let valMaxMiles = simulator.fidelity.valMaxMiles;
			let valMinMiles = simulator.fidelity.valMinMiles;
			let errorQuant = this.state.errorQuant;
			let enabled = this.state.enabled;

			// Regra do Palacio/Rafa de limitar a 150k
			valMaxMiles = valMaxMiles <= 150000 ? valMaxMiles : 150000;

			if (val >= valMinMiles && val <= valMaxMiles) {
				enabled = true;
				errorQuant = "";
			} else if (val < valMinMiles) {
				enabled = false;
				errorQuant = `A quantidade precisa ser no mínimo ${intFormat(valMinMiles)} milhas`;
			} else {
				enabled = false;
				errorQuant = `A quantidade precisa ser no máximo ${intFormat(valMaxMiles)} milhas`;
			}

			this.setState({ errorQuant, rankingValue: val, enabled: enabled });
		};

		let boxStyleButton = [];
		boxStyleButton.push("btn-gray-sm-o");

		const buttonSimulator = createElement(
			Button,
			{
				className: boxStyleButton.join(" "),
				disabled: !this.state.enabled,
				onClick: this.getRanksByFidelityAndMilesFn,
				"data-action": "ranking-ranking-table-simulate"
			},
			<span>Simular</span>
		);

		const handleMessageFn = e => {
			this.setState({
				handleMessage: !this.state.handleMessage
			});
		};

		const buttonArrowMessage = createElement(
			Button,
			{
				className: "btn-green-md-label offers-ranking-page--message-button",
				onClick: handleMessageFn,
				"data-action": "ranking-ranking-table-message"
			},
			this.state.handleMessage ? <i className="icon-arrow-up" /> : <i className="icon-arrow-down" />
		);

		return (
			<Fragment>
				<h2 className="offers-ranking-page__title text-center pt-32 ">RANKING DE OFERTAS</h2>
				<p
					className="offers-ranking-page--p text-center font-size-small plr-16"
					style={{ maxHeight: this.state.handleMessage ? "80px" : "0px" }}
				>
					Informe uma quantidade de milhas para simular uma venda de passagem e
					<br />
					veja as 15 primeiras ofertas ativas que possuem quantidade de milhas igual ou superior.
				</p>
				{buttonArrowMessage}

				<div className="offers-ranking-page__cards">
					<Card className="offers-ranking-page__cards--table-ranking">
						<p className="offers-ranking-page__cards--table-ranking--p">
							Simule a quantidade de milhas de uma passagem para ver o ranking de ofertas:
							{/* <span
								className="offers-ranking-page__cards--table-ranking--span"
								onClick={handleMessageFn}
							>
								?
							</span> */}
						</p>

						{/* <div
							className="offers-ranking-page__cards--table-ranking--div notice"
							style={{
								maxHeight: this.state.handleMessage ? "80px" : "0px",
								padding: this.state.handleMessage ? "8px 16px" : "0px"
							}}
						>
							Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse commodo, metus
							vitae tincidunt pulvinar.
						</div> */}

						<div className="offers-ranking-page--input-n-button">
							<InputCurrency
								onChange={(a, b) => onChangeFn(a, b)}
								value={this.state.rankingValue}
								precision="0"
								className="offers-ranking-page__simulator--input"
								placeholder="Milhas"
								errorMessage={this.state.errorQuant}
								maxLength={7}
								data-action="ranking-ranking-table-miles"
							/>
							{buttonSimulator}
						</div>
						<div className="clearfix" />

						{this.state.ranking ? (
							this.state.rankingLoading ? (
								<Loading />
							) : (
								<div className="offers-ranking-page__table">
									<div className="offers-ranking-page__table--thead">
										<div className="offers-ranking-page__table--thead--row">
											<div className="offers-ranking-page__table--thead--row--th w15">Posição</div>
											<div className="offers-ranking-page__table--thead--row--th w20">Vendedor</div>
											<div className="offers-ranking-page__table--thead--row--th w20">Valor</div>
											<div className="offers-ranking-page__table--thead--row--th w20">
												Qtd. de milhas
											</div>
											<div className="offers-ranking-page__table--thead--row--th w25">
												Última venda
											</div>
										</div>
									</div>
									<div className="offers-ranking-page__table--tbody">
										{this.state.rankingOffers.map((offer, idx) => {
											if (offer.myPosition) {
												haveMyPosition = true;
											}
											return (
												<div
													key={idx}
													className={`${offer.myPosition ? "table-my-row" : ""
														} offers-ranking-page__table--tbody--row`}
												>
													<div className="offers-ranking-page__table--tbody--row--td w15">
														{intFormat(offer.position)}º
													</div>
													<div className="offers-ranking-page__table--tbody--row--td w20">
														{offer.name}
													</div>
													<div className="offers-ranking-page__table--tbody--row--td w20">
														{formatCurrency(offer.price.replace(",", "."))}
													</div>
													<div className="offers-ranking-page__table--tbody--row--td w20">
														{intFormat(offer.miles)}
													</div>
													<div className="offers-ranking-page__table--tbody--row--td w25">
														{offer.lastSaleDate}
													</div>
												</div>
											);
										})}
										{haveMyPosition ? (
											<Fragment />
										) : (
											<div className="table-my-row offers-ranking-page__table--tbody--row p-16">
												Sua posição não foi exibida porque você tem uma quantidade de milhas menor
												do que a informada na simulação.
											</div>
										)}
									</div>
								</div>
							)
						) : (
							<Fragment />
						)}
					</Card>
				</div>
			</Fragment>
		);
	}
}

export default RankingRankingTable;
